import React, { FC, ReactNode } from 'react';

import classes from './PopUpTitle.style.module.scss';

export type PopUpTitleProps = {
  title: ReactNode;
  onClose: () => void;
};

export const PopUpTitle: FC<PopUpTitleProps> = ({ onClose, title }) => (
  <div className={classes.wrapper}>
    <span color="primary" className={classes.title}>
      {title}
    </span>
    <button
      type="button"
      onClick={onClose}
      className={classes.closeButton}
      data-testid="PopUpDeliveryLocation-component-closeButton"
    >
      <img src="/images/close.svg" alt="" />
    </button>
  </div>
);
